<template>
    <div>
        <label class="m-0">
            <bootstrap-toggle
                v-model="checked"
                :options="{ on: 'On', off: 'Off' }"
                data-onstyle="success"
                data-offstyle="danger"
                data-size="small"
            />
        </label>
    </div>
</template>

<script>
import BootstrapToggle from "vue-bootstrap-toggle";

export default {
    props: [ "payment", "shop" ],
    components: { BootstrapToggle },
    data() {
        return {
          checked: this.payment?.status_active == 1 ? true
            : this.payment?.status_active == 0 ? false
            : false
        };
    },
    watch: {
        checked(val) {
            this.toggle();
        }
    },
    methods: {
        toggle() {
            axios
              .patch(`/backend/s/${this.shop}/payments/${this.payment.id}/update-is-action`, {
                status_active: this.checked
              })
              .then((res) => {

              })
              .catch((err) => {

              });
        }
    }
};
</script>
